module.exports = __webpack_public_path__ + "img/information-archive.94f37572.png";